import img_03d70b44_c412_472f_a02f_6af1a09f3ca2 from "../../../images/vacancies/03d70b44-c412-472f-a02f-6af1a09f3ca2.jpg";
import img_a55f66a5_117b_4425_8117_26ce611e310a from "../../../images/vacancies/a55f66a5-117b-4425-8117-26ce611e310a.jpg";
import img_c20b47a9_1a1a_463a_9d07_c0a8563d27f1 from "../../../images/vacancies/c20b47a9-1a1a-463a-9d07-c0a8563d27f1.jpg";
import img_d767f672_91c7_4561_bd5a_9f5981f3b33d from "../../../images/vacancies/d767f672-91c7-4561-bd5a-9f5981f3b33d.jpg";
import img_ddfdef0d_992a_43af_8c88_9f818f694935 from "../../../images/vacancies/ddfdef0d-992a-43af-8c88-9f818f694935.jpg";
import img_default from "../../../images/vacancies/default.jpg";
import img_e5aa492d_5737_4b78_9fd1_19ec64c7e72f from "../../../images/vacancies/e5aa492d-5737-4b78-9fd1-19ec64c7e72f.jpg";
import img_06c7b28b_b067_4e84_8e47_4c846a56de17 from "../../../images/vacancies/gastro.jpg";
import img_sam42_administration_powertrust from "../../../images/vacancies/pt_sam42_administration.jpg";
import img_sam42_manualwork_powertrust from "../../../images/vacancies/pt_sam42_manualwork.jpg";
import img_sam42_sales_powertrust from "../../../images/vacancies/pt_sam42_sales.jpg";
import img_sam42_administration from "../../../images/vacancies/sam42_administration.jpg";
import img_sam42_banking from "../../../images/vacancies/sam42_banking.jpg";
import img_sam42_design from "../../../images/vacancies/sam42_design.jpg";
import img_sam42_engineering from "../../../images/vacancies/sam42_engineering.jpg";
import img_sam42_finance from "../../../images/vacancies/sam42_finance.jpg";
import img_sam42_hr from "../../../images/vacancies/sam42_hr.jpg";
import img_sam42_it from "../../../images/vacancies/sam42_it.jpg";
import img_sam42_law from "../../../images/vacancies/sam42_law.jpg";
import img_sam42_management from "../../../images/vacancies/sam42_management.jpg";
import img_sam42_manualwork from "../../../images/vacancies/sam42_manualwork.jpg";
import img_sam42_marketing from "../../../images/vacancies/sam42_marketing.jpg";
import img_sam42_purchase from "../../../images/vacancies/sam42_purchase.jpg";
import img_sam42_sales from "../../../images/vacancies/sam42_sales.jpg";
import img_sam42_science from "../../../images/vacancies/sam42_science.jpg";
import img_8b3f3138_d322_468c_8ed1_f0d5e9b2ce02 from "../../../images/vacancies/sonstige.jpg";
import img_7dcf67b1_cb9a_4b41_aef8_41e65d2f6abb from "../../../images/vacancies/transport.jpg";

const categoryImages = {
    sam42_administration: img_sam42_administration,
    sam42_banking: img_sam42_banking,
    sam42_design: img_sam42_design,
    sam42_engineering: img_sam42_engineering,
    sam42_finance: img_sam42_finance,
    "06c7b28b-b067-4e84-8e47-4c846a56de17":
        img_06c7b28b_b067_4e84_8e47_4c846a56de17,
    sam42_science: img_sam42_science,
    sam42_hr: img_sam42_hr,
    sam42_it: img_sam42_it,
    sam42_law: img_sam42_law,
    sam42_management: img_sam42_management,
    sam42_manualwork: img_sam42_manualwork,
    sam42_marketing: img_sam42_marketing,
    sam42_purchase: img_sam42_purchase,
    "e5aa492d-5737-4b78-9fd1-19ec64c7e72f":
        img_e5aa492d_5737_4b78_9fd1_19ec64c7e72f,
    sam42_sales: img_sam42_sales,
    "8b3f3138-d322-468c-8ed1-f0d5e9b2ce02":
        img_8b3f3138_d322_468c_8ed1_f0d5e9b2ce02,
    "7dcf67b1-cb9a-4b41-aef8-41e65d2f6abb":
        img_7dcf67b1_cb9a_4b41_aef8_41e65d2f6abb,
    "d767f672-91c7-4561-bd5a-9f5981f3b33d":
        img_d767f672_91c7_4561_bd5a_9f5981f3b33d,
    "a55f66a5-117b-4425-8117-26ce611e310a":
        img_a55f66a5_117b_4425_8117_26ce611e310a,
    "ddfdef0d-992a-43af-8c88-9f818f694935":
        img_ddfdef0d_992a_43af_8c88_9f818f694935,
    "c20b47a9-1a1a-463a-9d07-c0a8563d27f1":
        img_c20b47a9_1a1a_463a_9d07_c0a8563d27f1,
    "03d70b44-c412-472f-a02f-6af1a09f3ca2":
        img_03d70b44_c412_472f_a02f_6af1a09f3ca2,
    default: img_default,
};

export const specificCompanyImages = {
    "Wilhelm Hoyer B.V. & Co. KG": {},
    "Finke Mineralölwerk GmbH": {},
    "Powertrust GmbH": {
        sam42_sales: img_sam42_sales_powertrust,
        sam42_manualwork: img_sam42_manualwork_powertrust,
        sam42_administration: img_sam42_administration_powertrust,
    },
    "Hoyer G.m.b.H.": {},
};

/**
 * Returns a category image for the given company and category id.
 * If nut possible, it returns the default.
 *
 * @param {*} vacancy
 * @returns
 */
export const getCategoryImage = (vacancy) => {
    const companyName = vacancy.company_name;
    const category =
        vacancy.categories.length > 0 ? vacancy.categories[0].id : "default";

    if (
        specificCompanyImages[companyName] &&
        specificCompanyImages[companyName][category]
    ) {
        return specificCompanyImages[companyName][category];
    }

    return categoryImages[category];
};

export default categoryImages;
